import React from 'react';
import { Link } from 'react-router-dom';
import { GenericModelList } from 'drf-react-by-schema';

import { useAppSelector } from 'src/app/hooks';

import EntrepostoCard from 'src/components/EntrepostoCard';

const MODEL = 'entreposto';

export default function EntrepostoList() {
  const { usuaria, key } = useAppSelector((state) => state.page);
  const indexField = 'nome';
  const columnFields = ['id', 'logomarca', 'nome', 'grupos_fornecedores', 'municipio'];
  const hiddenFields = ['id'];
  const minWidthFields = { comunidade: 170, grupos: 250 };

  if (!usuaria) {
    return null;
  }

  return (
    <GenericModelList
      model={MODEL}
      isEditable={true}
      indexField={indexField}
      columnFields={columnFields}
      hiddenFields={hiddenFields}
      minWidthFields={minWidthFields}
      paginationMode="server"
      indexFieldBasePath={`/${key}/view/`}
      LinkComponent={Link}
      MobileListRenderItem={EntrepostoCard}
      tableAutoHeight={true}
      hasHeader={false}
      hideQuickFilterBar={false}
    />
  );
}
